import { render, staticRenderFns } from "./AccountGroup.vue?vue&type=template&id=73d95a7a&"
import script from "./AccountGroup.vue?vue&type=script&lang=js&"
export * from "./AccountGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports